module.exports = __webpack_public_path__ + "img/131.8be4eff1.png";